import { render } from "./WalletLink.vue?vue&type=template&id=1d237d35&scoped=true"
import script from "./WalletLink.vue?vue&type=script&lang=js"
export * from "./WalletLink.vue?vue&type=script&lang=js"

import "./WalletLink.vue?vue&type=style&index=0&id=1d237d35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d237d35"]])

export default __exports__